/** Join truthy class strings — the UI kit's tiny classNames helper. */
export const cx = (...classes: Array<string | false | null | undefined>): string =>
  classes.filter(Boolean).join(' ');
